export const sources={webp:"__VITE_ASSET__DNKys8Hm__ 96w"};export const img={src:"__VITE_ASSET__O1o$Mhfb__",w:96,h:130};export default{sources:sources,img:img};